export default "__VITE_PUBLIC_ASSET__36e9e31a__"